
































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { UserMetaKeys } from "@/data/enums/users";
import { ListDisplayMode } from "@/data/constants";
import { CreateElement } from "vue";
import { DefaultTaxTagFilters } from "@/data/filters/tax/tags";
import { DefaultTaxTagSorters } from "@/data/sorters/tax/tags";
import TaxTagsProvider from "@/components/app/global/tax/tags/taxTagsProvider.vue";
import TaxTagsTableView from "@/components/app/global/tax/tags/taxTagsTableView.vue";
import TaxTagsGridView from "@/components/app/global/tax/tags/taxTagsGridView.vue";
import { ITaxTag } from "@/models/tax";

@Component({
  components: {
    TaxTagsProvider
  }
})
export default class TaxTagsListing extends Vue {
  @Ref("taxTagsProvider")
  public taxTagsProvider!: TaxTagsProvider;

  // Props

  @Prop({ default: "TTGP" /* Tax TAGS Provider */ })
  public declare id: string;

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: TaxTagsListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => () => ({}) })
  public manualFilters!: (
    vm?: TaxTagsListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => DefaultTaxTagFilters })
  public availableFilters!: (vm?: TaxTagsProvider) => IFilter[];

  @Prop({ default: () => DefaultTaxTagSorters })
  public availableSorters!: (vm?: TaxTagsProvider) => ISorter[];

  @Prop({ default: () => [] })
  public checkedTaxTagsIds!: ITaxTag["id"][];

  // Data
  public displayModeStoragePath = UserMetaKeys.UI_TAX_TAGS_VIEW;
  public displayMode = ListDisplayMode.GRID;

  public declare $refs: {
    taxTagsProvider: TaxTagsProvider;
  };

  // Computed

  public get isDisplayModeTable() {
    return this.displayMode === ListDisplayMode.TABLE;
  }

  public get isDisplayModeGrid() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get taxTagsManualFilters() {
    return {
      ...this.manualFilters,
      ...this.routeFilters(this)
    };
  }

  public get listComponent() {
    return {
      render: (h: CreateElement) => {
        if (this.displayMode === ListDisplayMode.GRID)
          return h(TaxTagsGridView, {
            props: {
              isCheckable: true,
              checkedTaxTagsIds: this.checkedTaxTagsIds
            },
            on: {
              update: (taxTag: ITaxTag) =>
                this.taxTagsProvider.openAddEditModal(taxTag),
              delete: (taxTag: ITaxTag) =>
                this.taxTagsProvider
                  .deleteTaxTag(taxTag)
                  .then(() => this.$emit("check", { isChecked: false, taxTag }))
                  .catch(() => ({})),
              check: ({ isChecked, taxTag }) =>
                this.$emit("check", { isChecked, taxTag })
            }
          });
        return h(TaxTagsTableView, {
          props: {
            isSimpleView: false,
            isCheckable: true,
            checkedTaxTagsIds: this.checkedTaxTagsIds
          },
          on: {
            "row-click": (taxTag: ITaxTag) =>
              this.taxTagsProvider.openAddEditModal(taxTag),
            delete: (taxTag: ITaxTag) =>
              this.taxTagsProvider
                .deleteTaxTag(taxTag)
                .then(() => this.$emit("check", { isChecked: false, taxTag }))
                .catch(() => ({})),
            check: ({ isChecked, taxTag }) =>
              this.$emit("check", { isChecked, taxTag })
          }
        });
      }
    };
  }
}
